export default __webpack_public_path__ + "static/media/style1.f97b9ff1.jpg";